import React from "react";

const SkillChip = ({ label, value }) => {
  const { voice, written } = value;

  const renderItem = (type, dotColor, _value) => (
    <div className="flex items-center gap-2">
      {/* <span className={`w-2 h-2 rounded-full ${dotColor}`}></span> */}
      <span className="text-gray-700">
        {type}: <span className="font-semibold">{_value}+</span>
      </span>
    </div>
  );

  return (
    <div className="space-y-2 text-sm font-medium">
      {label?.toLowerCase() === "voice" &&
        renderItem("Voice", "bg-blue-500", `V${voice}`)}

      {label?.toLowerCase() === "written" &&
        renderItem("Written", "bg-purple-500", written)}

      {label?.toLowerCase() === "both" && (
        <>
          {renderItem("Voice", "bg-blue-500", `V${voice}`)}
          {renderItem("Written", "bg-purple-500", written)}
        </>
      )}
    </div>
  );
};

export default SkillChip;
